var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepyFace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268.76,
    height: 243.087,
    viewBox: "0 0 71.109 64.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.669 328.81h5.304v-5.329h-5.304z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.316 349.109h5.304v-5.329h-5.304z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.489 349.109h5.304v-5.329h-5.304z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.475 360.982h11.779v-16.831h-11.779z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.082 328.81h5.303v-5.329h-5.303z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.901 349.109h5.304v-5.329h-5.304z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.655 340.683h11.779v-16.831h-11.779z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.054 243.127h40.921v-4.219h-40.921z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.466 272.247h17.915v-12.985h-17.915z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.651 272.247h17.915v-12.985h-17.915z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.05 342.973h142.728V178.667H800.05z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a15.504 15.504 0 0 1-7.604 3.839c-7.411 1.41-14.162-2.699-15.094-9.186-.955-6.493 4.296-12.928 11.683-14.344a15 15 0 0 1 5.37-.04c-10.871-25.568-33.699-43.221-60.048-43.221-26.285 0-49.063 17.566-59.965 43.034a14.947 14.947 0 0 1 3.98.227c7.388 1.416 12.638 7.851 11.684 14.344-.933 6.487-7.684 10.596-15.094 9.186A15.617 15.617 0 0 1-131.53.933a88.329 88.329 0 0 0-.98 13.035c0 42.413 29.973 76.918 66.817 76.918 36.842 0 66.818-34.505 66.818-76.918A88.14 88.14 0 0 0 0 0m-65.693 96.119c-39.351 0-71.364-36.852-71.364-82.151 0-45.297 32.013-82.155 71.364-82.155 39.349 0 71.365 36.858 71.365 82.155 0 45.299-32.016 82.151-71.365 82.151",
    transform: "translate(937.106 246.853)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#b)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-1.012 0-1.832-.945-1.832-2.109 0-3.671-2.374-6.658-5.292-6.658-2.92 0-5.294 2.987-5.294 6.658 0 1.164-.82 2.109-1.832 2.109s-1.832-.945-1.832-2.109c0-5.997 4.018-10.876 8.958-10.876 4.938 0 8.956 4.879 8.956 10.876C1.832-.945 1.012 0 0 0",
    transform: "translate(841.733 272.248)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#c)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-1.012 0-1.832-.945-1.832-2.109 0-3.671-2.374-6.658-5.292-6.658-2.92 0-5.294 2.987-5.294 6.658 0 1.164-.821 2.109-1.833 2.109s-1.832-.945-1.832-2.109c0-5.997 4.018-10.876 8.959-10.876 4.938 0 8.956 4.879 8.956 10.876C1.832-.945 1.012 0 0 0",
    transform: "translate(919.549 272.248)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#d)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-37.256c-1.012 0-1.833-.944-1.833-2.109 0-1.164.821-2.11 1.833-2.11H0c1.012 0 1.833.946 1.833 2.11C1.833-.944 1.012 0 0 0",
    transform: "translate(892.143 243.127)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#e)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-1.026a14.37 14.37 0 0 1-2.315-.203l-.088.169c.761.877 1.553 2.056 2.198 3.036l3.602 5.497c.294.472.442 1.079.442 1.586 0 .741-.237 1.584-.616 2.867H-8c-.147-.709-.265-1.484-.265-2.295 0-.505.06-1.079.177-1.619h2.257c1.055 0 2.548.136 3.634.271l.085-.169c-.672-.809-1.67-2.091-2.371-3.17L-7.942.64c-.496-.707-.645-1.383-.645-1.955 0-.608.117-1.317.499-2.565H.761c1.815 0 2.43.945 2.43 2.328 0 .708-.144 1.214-.466 2.124C1.903.1.878 0 0 0",
    transform: "translate(950.242 327.731)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#f)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.761 0-1.698-.236-2.285-.606-.266-.642-.351-1.654-.351-2.059 0-.404.085-1.416.351-2.024.587-.439 1.524-.64 2.285-.64.762 0 1.729.201 2.314.64.265.608.354 1.62.354 2.024 0 .405-.089 1.417-.354 2.059C1.729-.236.762 0 0 0",
    transform: "translate(958.306 328.81)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#g)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.761 0-1.698-.236-2.283-.606-.265-.642-.353-1.654-.353-2.059 0-.404.088-1.416.353-2.024.585-.439 1.522-.64 2.283-.64.764 0 1.73.201 2.317.64.262.608.351 1.62.351 2.024 0 .405-.089 1.417-.351 2.059C1.73-.236.764 0 0 0",
    transform: "translate(966.718 328.81)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#h)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-1.025A14.36 14.36 0 0 1-3.34-.203l-.088.169c.761.877 1.553 2.056 2.198 3.036l3.602 5.497a3.15 3.15 0 0 1 .441 1.586c0 .741-.236 1.585-.616 2.867H-7.999c-.148-.709-.266-1.484-.266-2.295 0-.505.06-1.079.177-1.619h2.257c1.055 0 2.548.137 3.634.271l.086-.168c-.673-.81-1.67-2.092-2.371-3.171L-7.942.64c-.496-.707-.645-1.383-.645-1.955 0-.608.117-1.316.499-2.564H.761c1.816 0 2.431.944 2.431 2.327 0 .709-.145 1.214-.467 2.124C1.904.101.878 0 0 0",
    transform: "translate(974.061 348.03)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#i)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.762 0-1.699-.236-2.286-.606-.265-.642-.351-1.654-.351-2.059 0-.404.086-1.416.351-2.024.587-.439 1.524-.64 2.286-.64.761 0 1.729.201 2.313.64.265.608.354 1.62.354 2.024 0 .405-.089 1.417-.354 2.059C1.729-.236.761 0 0 0",
    transform: "translate(982.126 349.109)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#j)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.762 0-1.699-.236-2.283-.606-.265-.642-.354-1.654-.354-2.059 0-.404.089-1.416.354-2.024.584-.439 1.521-.64 2.283-.64.764 0 1.729.201 2.316.64.263.608.351 1.62.351 2.024 0 .405-.088 1.417-.351 2.059C1.729-.236.764 0 0 0",
    transform: "translate(990.538 349.109)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89999402
    },
    clipPath: "url(#k)",
    transform: "matrix(.35278 0 0 -.35278 -282.24 127.346)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.584.37-1.553.606-2.313.606C-3.075.606-4.013.37-4.6 0c-.264-.642-.35-1.653-.35-2.059 0-.404.086-1.416.35-2.024.587-.438 1.525-.64 2.287-.64.76 0 1.729.202 2.313.64.265.608.354 1.62.354 2.024C.354-1.653.265-.642 0 0",
    transform: "translate(1001.266 348.503)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepyFace);
export default __webpack_public_path__ + "static/media/sleepy_face.0fc9464cd926aa67d4f0c9224897cfb4.svg";
export { ForwardRef as ReactComponent };